import React from "react";
import {Modal} from "react-bootstrap"
import PriceEstimator from "../containers/priceEstimator";

class PriceEstimateModel extends React.Component {
    handleClose = () => {
        this.props.handleClose()
    }

    render() {
        let {show, closeModal = '', btnText} = this.props
        return (
            <Modal show={show} onHide={this.handleClose}
                   size="lg"
                   dialogClassName={'priceEstimatorModal'}>
                <Modal.Header closeButton>
                    <Modal.Title>Price Estimator</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PriceEstimator closeModal={closeModal} btnText={btnText}/>
                </Modal.Body>
            </Modal>
        )
    }
}

export default PriceEstimateModel;
